export class JigsawGenerator{
	constructor(tempCanvas = undefined){
		this.gen = (tempCanvas) ? tempCanvas : document.createElement('canvas');
		this.gctx = this.gen.getContext("2d");
	}

	generatePuzzle(imgUrl){
		this.img = new Image(500, 500);
		this.img.onload = () => {this.imageLoadComplete()};
		this.img.setAttribute("crossorigin", "anonymous");
		this.img.src = imgUrl;
		// console.log(this.img);
	}

	resizeGenCanvas(top, right, bottom, left){
		return {
			width: 125 + (40 * right) + (40 * left),
			height: 125 + (40 * top) + (40 * bottom)
		}
	}

	imageLoadComplete(){
		var pieces = [];
		var data = null
		var holder = null;

		//Generate piece 00
		this.gen.width = this.resizeGenCanvas(0, 1, 0, 0).width;
		this.gen.height = this.resizeGenCanvas(0, 1, 0, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.moveTo(0, 0);
			this.gctx.rect(0, 0, 125, 125);
			this.gctx.arc(125, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, 0, 0, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(125/2, 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"00", data: data});


		//Generate piece 01
		this.gen.width = this.resizeGenCanvas(0, 0, 1, 0).width;
		this.gen.height = this.resizeGenCanvas(0, 0, 1, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.moveTo(0, 0);
			this.gctx.rect(0, 0, 125, 125);
			this.gctx.arc(125/2, 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, -125, 0, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(125, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.arc(0, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"01", data: data});
		

		//Generate piece 02
		this.gen.width = this.resizeGenCanvas(0, 1, 0, 1).width;
		this.gen.height = this.resizeGenCanvas(0, 1, 0, 1).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(40, 0, 125, 125);
			this.gctx.arc(40 + 125, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.arc(40, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, (-125 * 2) + 40, 0, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(this.gen.width / 2, 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"02", data: data});
		

		//Generate piece 03
		this.gen.width = this.resizeGenCanvas(0, 0, 0, 0).width;
		this.gen.height = this.resizeGenCanvas(0, 0, 0, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(0, 0, 125, 125);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, (-125 * 3), 0, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(this.gen.width / 2, 125, 40, 0, 2 * Math.PI);
			this.gctx.arc(0, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"03", data: data});
		

		//Generate piece 10
		this.gen.width = this.resizeGenCanvas(1, 0, 1, 0).width;
		this.gen.height = this.resizeGenCanvas(1, 0, 1, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(0, 40, 125, 125);
			this.gctx.arc(125/2, 40, 40, 0, 2 * Math.PI);
			this.gctx.arc(125/2, 40 + 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, 0, -85, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(this.gen.width, (125/2) + 40, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"10", data: data});
		

		//Generate piece 11
		this.gen.width = this.resizeGenCanvas(0, 1, 0, 1).width;
		this.gen.height = this.resizeGenCanvas(0, 1, 0, 1).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(40, 0, 125, 125);
			this.gctx.arc(125+40, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.arc(40, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, -125 +40, -125, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(this.gen.width/2, 0, 40, 0, 2 * Math.PI);
			this.gctx.arc(this.gen.width/2, 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"11", data: data});
		

		//Generate piece 12
		this.gen.width = this.resizeGenCanvas(1, 0, 1, 0).width;
		this.gen.height = this.resizeGenCanvas(1, 0, 1, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(0, 40, 125, 125);
			this.gctx.arc(125/2, 40, 40, 0, 2 * Math.PI);
			this.gctx.arc(125/2, 40 + 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, -250, -85, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(0, (125/2) + 40, 40, 0, 2 * Math.PI);
			this.gctx.arc(125, (125/2) + 40, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"12", data: data});
		

		//Generate piece 13
		this.gen.width = this.resizeGenCanvas(1, 0, 1, 1).width;
		this.gen.height = this.resizeGenCanvas(1, 0, 1, 1).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(40, 40, 125, 125);
			this.gctx.arc((125/2) + 40, 40, 40, 0, 2 * Math.PI);
			this.gctx.arc((125/2) + 40, 40 + 125, 40, 0, 2 * Math.PI);
			this.gctx.arc(40, 40 + (125/2), 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, -335, -85, this.img.width, this.img.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"13", data: data});


		//Generate piece 20
		this.gen.width = this.resizeGenCanvas(0, 1, 0, 0).width;
		this.gen.height = this.resizeGenCanvas(0, 1, 0, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.moveTo(0, 0);
			this.gctx.rect(0, 0, 125, 125);
			this.gctx.arc(125, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, 0, -250, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(125/2, 0, 40, 0, 2 * Math.PI);
			this.gctx.arc(125/2, 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"20", data: data});
		

		//Generate piece 21
		this.gen.width = this.resizeGenCanvas(1, 0, 1, 0).width;
		this.gen.height = this.resizeGenCanvas(1, 0, 1, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(0, 40, 125, 125);
			this.gctx.arc(125/2, 40, 40, 0, 2 * Math.PI);
			this.gctx.arc(125/2, 40 + 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, -125, -85 - 125, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(0, (125/2) + 40, 40, 0, 2 * Math.PI);
			this.gctx.arc(125, (125/2) + 40, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"21", data: data});
		

		//Generate piece 22
		this.gen.width = this.resizeGenCanvas(0, 1, 0, 1).width;
		this.gen.height = this.resizeGenCanvas(0, 1, 0, 1).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(40, 0, 125, 125);
			this.gctx.arc(125+40, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.arc(40, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, -250 +40, -250, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(this.gen.width/2, 0, 40, 0, 2 * Math.PI);
			this.gctx.arc(this.gen.width/2, 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"22", data: data});
		

		//Generate piece 23
		this.gen.width = this.resizeGenCanvas(0, 0, 1, 0).width;
		this.gen.height = this.resizeGenCanvas(0, 0, 1, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(0, 0, 125, 125);
			this.gctx.arc(this.gen.width / 2, 125, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, (-125 * 3), -250, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(this.gen.width / 2, 0, 40, 0, 2 * Math.PI);
			this.gctx.arc(0, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"23", data: data});
		

		//Generate piece 30
		this.gen.width = this.resizeGenCanvas(1, 0, 0, 0).width;
		this.gen.height = this.resizeGenCanvas(1, 0, 0, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(0, 40, 125, 125);
			this.gctx.arc(125/2, 40, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, 0, -375 + 40, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(this.gen.width, (125/2) + 40, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"30", data: data});
		

		//Generate piece 31
		this.gen.width = this.resizeGenCanvas(0, 0, 0, 1).width;
		this.gen.height = this.resizeGenCanvas(0, 0, 0, 1).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(40, 0, 125, 125);
			this.gctx.arc(40, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, -125 + 40, -375, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(40 + (125/2), 0, 40, 0, 2 * Math.PI);
			this.gctx.arc(40 + (125), 125/2, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"31", data: data});
		

		//Generate piece 32
		this.gen.width = this.resizeGenCanvas(1, 1, 0, 1).width;
		this.gen.height = this.resizeGenCanvas(1, 1, 0, 1).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(40, 40, 125, 125);
			this.gctx.arc(40 + (125/2), 40, 40, 0, 2 * Math.PI);
			this.gctx.arc(40 + (125), 40 + (125/2), 40, 0, 2 * Math.PI);
			this.gctx.arc(40, 40 +(125/2), 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, -250 + 40, -375 + 40, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"32", data: data});
		

		//Generate piece 33
		this.gen.width = this.resizeGenCanvas(0, 0, 0, 0).width;
		this.gen.height = this.resizeGenCanvas(0, 0, 0, 0).height;
		this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH STARTS HERE
			this.gctx.beginPath();
			this.gctx.rect(0, 0, 125, 125);
			this.gctx.closePath();
			this.gctx.clip();
			//DRAW THE IMAGE IN
			this.gctx.drawImage(this.img, -375, -375, this.img.width, this.img.height);
			this.gctx.beginPath();
			this.gctx.arc(0, 125/2, 40, 0, 2 * Math.PI);
			this.gctx.arc(125/2, 0, 40, 0, 2 * Math.PI);
			this.gctx.closePath();
			this.gctx.clip();
			this.gctx.clearRect(0, 0, this.gen.width, this.gen.height);
		//PATH ENDS HERE
		data = this.gen.toDataURL("image/png");
		pieces.push({pos:"33", data: data});

		// console.log(pieces);
		if(this.onSplitDone)this.onSplitDone(pieces);
	}
}